<template>
    <modal
        ref="errorMessageModal"
        title="Something went wrong"
        actionText="Dismiss"
        contentClass="error-message-window"
    >
        <ul class="error--text">
            <li v-for="(error, field) in errors" :key="`error-message-${field}`">
                {{ error }}
            </li>
        </ul>
    </modal>
</template>

<script>
    import Modal from '~/components/Shared/UIComponents/Modal';

    export default {
        name: 'ErrorMessages',
        components: {
            Modal
        },
        data() {
            return {
                errors: {},
                maxUploadSize: '64 MB'
            }
        },
        watch: {
            errors: {
                async handler() {
                    if (await this.$refs.errorMessageModal.open() === false) {
                        return;
                    }
                    if (key(this.errors[0]) !== 'document') {
                        this.$router.go(0);
                    }
                },
                deep: true
            }
        },
        mounted() {
            window.intercepted.$on('response:client-error', data => {
                // Ignore any status codes handled elsewhere
                if ([401, 403, 440].includes(data.status)) {
                    return false;
                }

                // Ignore sanction check not found, this is handled on front end
                if (data.status === 404 && data.body.includes('sanctions')) {
                    return false;
                }

                if (data.status === 413) {
                    this.errors = [this.maxUploadSizeError];
                    return;
                }
                this.errors = data.body;
            });

            window.intercepted.$on('response:5xx', data => {
                console.log('5xx response');
            });
        },
        computed: {
            maxUploadSizeError() {
                return 'The file is too large and cannot be uploaded. Maximum size is ' + this.maxUploadSize;
            }
        }
    }
</script>

<style lang="scss">
    .x-dialog.error-message-window {
        z-index: 300;
    }
</style>
